import {CustomerOption, OnboardingClient, SubmissionModel} from "../../client/OnboardingClient";
import {Organisation, UserClient} from "../../client/UserClient";
import {OnboardingForm} from "../OnboardingForm";
import * as React from "react";
import {useEffect, useState} from "react";
import {ImportBuilding} from "../common/UploadComponents";

export interface OnboardingPageProps {
    onboardingClient: OnboardingClient
    userClient: UserClient
}

export const OnboardingPage = ({onboardingClient, userClient}: OnboardingPageProps)=>  {
    const [customers, setCustomers] = useState<CustomerOption[]>([])
    const [orgs, setOrgs] = useState<Organisation[]>([])

    useEffect(() => {
        onboardingClient.retrieveCustomers().then(customers => customers.map(setCustomers))
    }, [onboardingClient])

    useEffect(() => {
        userClient.loadAllOrganisations().then(orgs => orgs.map(setOrgs))
    }, [userClient])

    return <>
        <ImportBuilding
            customers={customers}
            orgs={orgs}
            className={'col mb-5'}
            onFileUpload={(customerId, orgs, file) => onboardingClient.uploadBuildingsToImport(customerId, orgs, file)}
        />

        <OnboardingForm
            handleSubmit={(data: SubmissionModel) => onboardingClient.postForm(data)}
            retrieveDeals={() => onboardingClient.retrieveNewDeals()}
            retrieveSuppliers={() => onboardingClient.retrieveSuppliers()}
            retrieveMops={() => onboardingClient.retrieveMops()}
            retrieveOrgs={() => userClient.loadAllOrganisations().then(o => o.fold(a => a, () => []))}
        />
    </>
}
